{
  "update-password-pin-dialog": {
    "buttons": {
      "resend": "Erneut senden",
      "submit": "Einreichen"
    },
    "text": {
      "enter-pin": "Bitte geben Sie Ihren PIN-Code ein, um Ihr neues Passwort zu bestätigen.",
      "in-second": "in {{seconds}} s",
      "password-updated": "Das Passwort wurde erfolgreich aktualisiert!",
      "pin-via-email": "Der PIN-Code wird Ihnen per E-Mail zugeschickt",
      "pin-via-sms": "Der PIN-Code wird an Ihre Telefonnummer zugeschickt",
      "update-password": "Passwort aktualisieren"
    }
  }
}
